import type { EstimationItemResponse } from '@/api/schema/data-contracts';

const findParent = (
  estimationItem: EstimationItemResponse,
  estimationItems: EstimationItemResponse[],
) =>
  estimationItem.parentId
    ? estimationItems.find((x) => x.id === estimationItem.parentId)
    : undefined;

export const buildHierarchicalOrderReferenceString = (
  currentEstimationItem: EstimationItemResponse,
  allEstimationItems: EstimationItemResponse[],
): string => {
  const parent = findParent(currentEstimationItem, allEstimationItems);
  return parent === undefined
    ? currentEstimationItem.order.toString()
    : `${buildHierarchicalOrderReferenceString(parent, allEstimationItems)}.${currentEstimationItem.order}`;
};
